export interface Plan {
  id: string;
  name: string;
  price: {
    monthly: number;
    yearly: number;
  };
  flux: number;
  advantages: string[];
}

export const plans: Plan[] = [
  {
    id: "basic",
    name: "Basic",
    price: {
      monthly: 65,
      yearly: 600,
    },
    flux: 4000,
    advantages: ["200 flux per month", "Medium resolution", "No watermark"],
  },
  {
    id: "pro",
    name: "Pro",
    price: {
      monthly: 150,
      yearly: 1200,
    },
    flux: 8000,
    advantages: [
      "700 flux per month",
      "Medium resolution",
      "No watermark",
      "Access to exclusive content",
    ],
  },
  {
    id: "premium",
    name: "Premium",
    price: {
      monthly: 550,
      yearly: 5000,
    },
    flux: 50000,
    advantages: [
      "2500 flux per month",
      "High resolution",
      "No watermark",
      "Access to exclusive content",
      "Priority support",
    ],
  },
];
